import { useState, useCallback } from "react";
import { financialReportService } from "../../services";

export const useFinancialReport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getSummary = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await financialReportService.getSummary(params);
      return result.data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const getTransactions = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await financialReportService.getTransactions(params);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    getSummary,
    getTransactions,
  };
};
